import { useAppBridge } from "@shopify/app-bridge-react";
import { useEffect, useState } from "react";

export const useIsReady = () => {
  const appBridge = useAppBridge();
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    let ignore = false;
    if (appBridge) {
      appBridge.ready.then(() => {
        if (ignore) return;
        // console.log("App Bridge is ready");
        setIsReady(true);
      });
    }
    return () => {
      ignore = true;
    };
  }, [appBridge]);
  // console.log("useIsReady", isReady);
  return isReady;
};
